export const hakofitDataCreationFeeJpy = 550;
export const hakofitDesignType = "box_storage";

export function formatJpy(value: number): string {
  return `${value.toLocaleString("ja-JP")}円`;
}
